import React from 'react';

/**
 * Adaptador local con la firma de `InputTextArea` (@ole/react-library-agents).
 * Hoy renderiza `textarea.ta` (Aura). Migración (OUW-72): `<InputTextArea … />`.
 * Divergencia: `testId` / `style` passthrough.
 */
export type PortalTextAreaProps = {
  id?: string;
  label?: string;
  required?: boolean;
  maxLength?: number;
  placeholder?: string;
  value?: string;
  rows?: number;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  style?: React.CSSProperties;
  testId?: string;
};

export function PortalTextArea({ id, label, required, maxLength, placeholder, value, rows, onChange, style, testId }: PortalTextAreaProps) {
  return (
    <>
      {label && (
        <label className="lbl" htmlFor={id}>
          {label}
        </label>
      )}
      <textarea
        className="ta"
        id={id}
        required={required}
        maxLength={maxLength}
        placeholder={placeholder}
        value={value}
        rows={rows}
        style={style}
        data-testid={testId}
        onChange={onChange}
      />
    </>
  );
}
